import * as React from 'react';
import Page from '../containers/Page'; 

export default () => (
  <Page title="Projects">
      projects page
    </Page>
)